export const CHARGING_POOL_QUERY_KEYS = {
	GET_CHARGING_POOL: "GET_CHARGING_POOL",
	GET_CHARGING_POOL_OFFERS: "GET_CHARGING_POOL_OFFERS",
} as const;
